/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type {
  AddJobsToCampaignPayload,
  AddSourcedCandidatesPayload,
  AddSourcedCandidatesResponse,
  AddSuggestedQuestionsCategoryPayload,
  AiCallerNameResponse,
  AllCandidateIdsResponse,
  AutoMatchSourcingSettingsResponse,
  BulkCancelCampaignResponse,
  BulkCancelMultiplePayload,
  BulkCancelPayload,
  BulkExportCandidateCampaignPayload,
  BulkExportPayload,
  BulkFeedbackResponse,
  BulkOperationResponse,
  BulkPauseResumeMultiplePayload,
  BulkPauseResumePayload,
  BulkPauseResumeResponse,
  BulkRemoveMultiplePayload,
  BulkRemovePayload,
  BulkRemoveResponse,
  BulkUpdateCandidateFeedbackPayload,
  CampaignInfoResponse,
  CampaignJobsResponse,
  CampaignQuestionsPaginatedResponse,
  CampaignScriptVersionsListResponse,
  CampaignStatsResponse,
  CampaignStatsSummaryResponse,
  CampaignTranscriptPermissionsResponse,
  CampaignsGetCampaignQuestionsPaginatedParams,
  CampaignsGetCampaignStatsBody,
  CampaignsGetCampaignStatsSummaryBody,
  CampaignsGetCandidatesWithCallsParams,
  CampaignsGetClientsParams,
  CampaignsGetNotificationsParams,
  CampaignsSaveScriptParams,
  CampaignsSearchOrgJobsForPickerParams,
  CandidateResumeDetailsResponse,
  CandidatesAndCallsResponse,
  CandidatesCallsPayload,
  ChatScreeningRequest,
  ChatScreeningResponse,
  ClientSearchResult,
  DeletedIdResponse,
  DuplicateCampaignResponse,
  GenerateScriptPayload,
  GenerateVideoReminderSequencePayload,
  GenerateVideoReminderSequenceResponse,
  GenerateVideoSmsReminderSequencePayload,
  GenerateVideoSmsReminderSequenceResponse,
  GeneratedScriptInfo,
  GetOrgCampaignsResponse,
  GradingCriteriaRequest,
  GradingCriteriaResponse,
  JobGenerationPreviewRequest,
  JobGenerationPreviewResponse,
  JobPickerSearchResult,
  JobsFilterPayload,
  MarkAllAsReviewedPayload,
  MarkAsReviewedResponse,
  MarkMultipleAsReviewedPayload,
  MarkQuestionsAsAnsweredPayload,
  MessageResponse,
  NotificationsCountPayload,
  NotificationsCountResponse,
  NotificationsPayload,
  NotificationsResponse,
  OrgCampaignJobSummaryMetricsResponse,
  OutroTemplatesResponse,
  PatchBackgroundInfoPayload,
  PatchBackgroundInfoResponse,
  PauseCampaignResponse,
  PermanentLinkQuestionsResponse,
  PropagateTemplatePayload,
  PropagationPreviewRequest,
  PropagationPreviewResponse,
  RegenerateAiBlockPayload,
  RegenerateAiBlockResponse,
  RegenerateSectionPayload,
  RegenerateSectionResponse,
  RegenerateSuggestedQuestionsPayload,
  RestoreScriptVersionResponse,
  ResumeCampaignResponse,
  ResumeFilteringSettingsResponse,
  ResumeReviewRequirementContract,
  SaveScriptResponse,
  SavedScriptPayload,
  ScheduleFollowUpUserEmailsResponse,
  ScoringOperationResponse,
  ScoringStartedResponse,
  ScreeningQuestionsResponse,
  ScriptGenerationJobAccepted,
  ScriptGenerationJobStatusResponse,
  ScriptReadResponse,
  ScriptTimestampsResponse,
  ScriptVersionDetailResponse,
  SearchCampaignsPayload,
  SearchCampaignsResponse,
  SourcingResumeRequirementContract,
  SubmitUninterestedResponse,
  SubmitWithdrawalPayload,
  SubmitWithdrawalResponse,
  SuggestedQuestionCategoriesResponse,
  SuggestedQuestionsResponse,
  TriggerBackgroundValidationResponse,
  TriggerValidationPayload,
  UninterestedInfoResponse,
  UpdateAutoActivateResponse,
  UpdateAutoMatchSourcingSettingsRequest,
  UpdateCallSummaryPayload,
  UpdateCallSummaryResponse,
  UpdateCampaignAutoActivatePayload,
  UpdateCampaignPermanentLinkQuestionsPayload,
  WebCallFeedbackRequest,
  WebCallFeedbackResponse,
  WithdrawalInfoResponse,
} from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getCampaigns = () => {
  /**
   * @summary Search Campaigns
   */
  const campaignsSearchCampaigns = (
    orgId: string,
    searchCampaignsPayload: SearchCampaignsPayload,
    options?: SecondParameter<typeof axiosInstance<SearchCampaignsResponse>>
  ) => {
    return axiosInstance<SearchCampaignsResponse>(
      {
        url: `/org/${orgId}/campaigns/search`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: searchCampaignsPayload,
      },
      options
    );
  };
  /**
   * Get org campaigns with filtering - POST endpoint for complex queries
   * @summary Get Org Campaigns Filtered
   */
  const campaignsGetOrgCampaignsFiltered = (
    orgId: string,
    jobsFilterPayload: JobsFilterPayload,
    options?: SecondParameter<typeof axiosInstance<GetOrgCampaignsResponse>>
  ) => {
    return axiosInstance<GetOrgCampaignsResponse>(
      {
        url: `/org/${orgId}/campaigns`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: jobsFilterPayload,
      },
      options
    );
  };
  /**
   * Search org jobs for lightweight picker modals (sourcing, template preview, etc.).
   * @summary Search Org Jobs For Picker
   */
  const campaignsSearchOrgJobsForPicker = (
    orgId: string,
    params?: CampaignsSearchOrgJobsForPickerParams,
    options?: SecondParameter<typeof axiosInstance<JobPickerSearchResult[]>>
  ) => {
    return axiosInstance<JobPickerSearchResult[]>(
      { url: `/org/${orgId}/jobs/picker/search`, method: 'GET', params },
      options
    );
  };
  /**
   * @summary Get Org Campaign Job Summary Metrics
   */
  const campaignsGetOrgCampaignJobSummaryMetrics = (
    orgId: string,
    options?: SecondParameter<
      typeof axiosInstance<OrgCampaignJobSummaryMetricsResponse>
    >
  ) => {
    return axiosInstance<OrgCampaignJobSummaryMetricsResponse>(
      { url: `/org/${orgId}/campaigns/job_summary_metrics`, method: 'GET' },
      options
    );
  };
  /**
   * @summary Get Campaign Stats Summary
   */
  const campaignsGetCampaignStatsSummary = (
    campaignId: string,
    campaignsGetCampaignStatsSummaryBody: CampaignsGetCampaignStatsSummaryBody,
    options?: SecondParameter<
      typeof axiosInstance<CampaignStatsSummaryResponse>
    >
  ) => {
    return axiosInstance<CampaignStatsSummaryResponse>(
      {
        url: `/campaigns/view/${campaignId}/stats/summary`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: campaignsGetCampaignStatsSummaryBody,
      },
      options
    );
  };
  /**
   * @summary Get Campaign Stats
   */
  const campaignsGetCampaignStats = (
    campaignId: string,
    campaignsGetCampaignStatsBody: CampaignsGetCampaignStatsBody,
    options?: SecondParameter<typeof axiosInstance<CampaignStatsResponse>>
  ) => {
    return axiosInstance<CampaignStatsResponse>(
      {
        url: `/campaigns/view/${campaignId}/stats`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: campaignsGetCampaignStatsBody,
      },
      options
    );
  };
  /**
   * @summary Get Candidate Resume Details For Campaign
   */
  const campaignsGetCandidateResumeDetailsForCampaign = (
    campaignId: string,
    candidateId: string,
    options?: SecondParameter<
      typeof axiosInstance<CandidateResumeDetailsResponse>
    >
  ) => {
    return axiosInstance<CandidateResumeDetailsResponse>(
      {
        url: `/campaigns/view/${campaignId}/candidate/${candidateId}/resume_details`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Resume Filtering Settings For Campaign
   */
  const campaignsGetResumeFilteringSettingsForCampaign = (
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<ResumeFilteringSettingsResponse>
    >
  ) => {
    return axiosInstance<ResumeFilteringSettingsResponse>(
      {
        url: `/campaigns/view/${campaignId}/resume_filtering_settings`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * Return the filtered interview count for the Interviews page stats row.
   * @summary Get Notifications Count
   */
  const campaignsGetNotificationsCount = (
    orgId: string,
    notificationsCountPayload: NotificationsCountPayload,
    options?: SecondParameter<typeof axiosInstance<NotificationsCountResponse>>
  ) => {
    return axiosInstance<NotificationsCountResponse>(
      {
        url: `/org/${orgId}/notifications/count`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: notificationsCountPayload,
      },
      options
    );
  };
  /**
   * @summary Get Notifications
   */
  const campaignsGetNotifications = (
    orgId: string,
    notificationsPayload: NotificationsPayload,
    params?: CampaignsGetNotificationsParams,
    options?: SecondParameter<typeof axiosInstance<NotificationsResponse>>
  ) => {
    return axiosInstance<NotificationsResponse>(
      {
        url: `/org/${orgId}/notifications`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: notificationsPayload,
        params,
      },
      options
    );
  };
  /**
   * @summary Get Candidates With Calls
   */
  const campaignsGetCandidatesWithCalls = (
    campaignId: string,
    candidatesCallsPayload: CandidatesCallsPayload,
    params?: CampaignsGetCandidatesWithCallsParams,
    options?: SecondParameter<typeof axiosInstance<CandidatesAndCallsResponse>>
  ) => {
    return axiosInstance<CandidatesAndCallsResponse>(
      {
        url: `/campaigns/view/${campaignId}/candidates_and_calls`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: candidatesCallsPayload,
        params,
      },
      options
    );
  };
  /**
   * @summary Bulk Export Campaign Candidates
   */
  const campaignsBulkExportCampaignCandidates = (
    campaignId: string,
    bulkExportPayload: BulkExportPayload,
    options?: SecondParameter<typeof axiosInstance<Blob>>
  ) => {
    return axiosInstance<Blob>(
      {
        url: `/campaigns/view/${campaignId}/bulk_export`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkExportPayload,
        responseType: 'blob',
      },
      options
    );
  };
  /**
   * @summary Bulk Export Candidates
   */
  const campaignsBulkExportCandidates = (
    bulkExportCandidateCampaignPayload: BulkExportCandidateCampaignPayload,
    options?: SecondParameter<typeof axiosInstance<Blob>>
  ) => {
    return axiosInstance<Blob>(
      {
        url: `/campaigns/view/bulk_export`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkExportCandidateCampaignPayload,
        responseType: 'blob',
      },
      options
    );
  };
  /**
   * @summary Get Clients
   */
  const campaignsGetClients = (
    params?: CampaignsGetClientsParams,
    options?: SecondParameter<typeof axiosInstance<ClientSearchResult[]>>
  ) => {
    return axiosInstance<ClientSearchResult[]>(
      { url: `/clients`, method: 'GET', params },
      options
    );
  };
  /**
   * Get outro templates for interview scripts (single source of truth).
   * @summary Get Outro Templates
   */
  const campaignsGetOutroTemplates = (
    options?: SecondParameter<typeof axiosInstance<OutroTemplatesResponse>>
  ) => {
    return axiosInstance<OutroTemplatesResponse>(
      { url: `/outro_templates`, method: 'GET' },
      options
    );
  };
  /**
   * @summary Get Ai Caller Name
   */
  const campaignsGetAiCallerName = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<AiCallerNameResponse>>
  ) => {
    return axiosInstance<AiCallerNameResponse>(
      {
        url: `/campaigns/view/${campaignId}/get_ai_caller_name`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Schedule Follow Up User Emails
   */
  const campaignsGetScheduleFollowUpUserEmails = (
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<ScheduleFollowUpUserEmailsResponse>
    >
  ) => {
    return axiosInstance<ScheduleFollowUpUserEmailsResponse>(
      {
        url: `/campaigns/view/${campaignId}/schedule_follow_up_user_emails`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get All Candidate Ids For Campaign
   */
  const campaignsGetAllCandidateIdsForCampaign = (
    campaignId: string,
    candidatesCallsPayload: CandidatesCallsPayload,
    options?: SecondParameter<typeof axiosInstance<AllCandidateIdsResponse>>
  ) => {
    return axiosInstance<AllCandidateIdsResponse>(
      {
        url: `/campaigns/view/${campaignId}/all_candidate_ids`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: candidatesCallsPayload,
      },
      options
    );
  };
  /**
   * @summary Pause Campaign
   */
  const campaignsPauseCampaign = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<PauseCampaignResponse>>
  ) => {
    return axiosInstance<PauseCampaignResponse>(
      { url: `/campaigns/edit/${campaignId}/pause`, method: 'POST' },
      options
    );
  };
  /**
   * @summary Get Campaign
   */
  const campaignsGetCampaign = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<CampaignInfoResponse>>
  ) => {
    return axiosInstance<CampaignInfoResponse>(
      {
        url: `/campaigns/view/${campaignId}/info_for_campaign_page`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Campaign Transcript Permissions
   */
  const campaignsGetCampaignTranscriptPermissions = (
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<CampaignTranscriptPermissionsResponse>
    >
  ) => {
    return axiosInstance<CampaignTranscriptPermissionsResponse>(
      {
        url: `/campaigns/view/${campaignId}/transcript_permissions`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Resume Campaign
   */
  const campaignsResumeCampaign = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<ResumeCampaignResponse>>
  ) => {
    return axiosInstance<ResumeCampaignResponse>(
      { url: `/campaigns/edit/${campaignId}/resume`, method: 'POST' },
      options
    );
  };
  /**
   * Update campaign auto-activation settings
   * @summary Update Campaign Settings
   */
  const campaignsUpdateCampaignSettings = (
    campaignId: string,
    updateCampaignAutoActivatePayload: UpdateCampaignAutoActivatePayload,
    options?: SecondParameter<typeof axiosInstance<UpdateAutoActivateResponse>>
  ) => {
    return axiosInstance<UpdateAutoActivateResponse>(
      {
        url: `/campaigns/edit/${campaignId}/auto-activate`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateCampaignAutoActivatePayload,
      },
      options
    );
  };
  /**
   * @summary Duplicate Campaign
   */
  const campaignsDuplicateCampaign = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<DuplicateCampaignResponse>>
  ) => {
    return axiosInstance<DuplicateCampaignResponse>(
      { url: `/campaigns/edit/${campaignId}/duplicate`, method: 'POST' },
      options
    );
  };
  /**
   * Patch only the background info and template IDs for a campaign, then re-validate.
   * @summary Patch Campaign Background Info
   */
  const campaignsPatchCampaignBackgroundInfo = (
    campaignId: string,
    patchBackgroundInfoPayload: PatchBackgroundInfoPayload,
    options?: SecondParameter<typeof axiosInstance<PatchBackgroundInfoResponse>>
  ) => {
    return axiosInstance<PatchBackgroundInfoResponse>(
      {
        url: `/campaigns/edit/${campaignId}/background_info`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: patchBackgroundInfoPayload,
      },
      options
    );
  };
  /**
   * @summary Get Campaign Requirements
   */
  const campaignsGetCampaignRequirements = (
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<ResumeReviewRequirementContract[]>
    >
  ) => {
    return axiosInstance<ResumeReviewRequirementContract[]>(
      { url: `/campaigns/view/${campaignId}/requirements`, method: 'GET' },
      options
    );
  };
  /**
   * @summary Get Campaign Sourcing Requirements
   */
  const campaignsGetCampaignSourcingRequirements = (
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<SourcingResumeRequirementContract[]>
    >
  ) => {
    return axiosInstance<SourcingResumeRequirementContract[]>(
      {
        url: `/campaigns/view/${campaignId}/sourcing-requirements`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Auto Match Sourcing Settings
   */
  const campaignsGetAutoMatchSourcingSettings = (
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<AutoMatchSourcingSettingsResponse>
    >
  ) => {
    return axiosInstance<AutoMatchSourcingSettingsResponse>(
      {
        url: `/campaigns/${campaignId}/auto_match_sourcing_settings`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Update Auto Match Sourcing Settings
   */
  const campaignsUpdateAutoMatchSourcingSettings = (
    campaignId: string,
    updateAutoMatchSourcingSettingsRequest: UpdateAutoMatchSourcingSettingsRequest,
    options?: SecondParameter<
      typeof axiosInstance<AutoMatchSourcingSettingsResponse>
    >
  ) => {
    return axiosInstance<AutoMatchSourcingSettingsResponse>(
      {
        url: `/campaigns/${campaignId}/auto_match_sourcing_settings`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateAutoMatchSourcingSettingsRequest,
      },
      options
    );
  };
  /**
   * @summary Update Campaign Jobs
   */
  const campaignsUpdateCampaignJobs = (
    campaignId: string,
    addJobsToCampaignPayload: AddJobsToCampaignPayload,
    options?: SecondParameter<typeof axiosInstance<CampaignJobsResponse>>
  ) => {
    return axiosInstance<CampaignJobsResponse>(
      {
        url: `/campaigns/edit/${campaignId}/jobs`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addJobsToCampaignPayload,
      },
      options
    );
  };
  /**
   * @summary Get Campaign Jobs
   */
  const campaignsGetCampaignJobs = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<CampaignJobsResponse>>
  ) => {
    return axiosInstance<CampaignJobsResponse>(
      { url: `/campaigns/view/${campaignId}/jobs`, method: 'GET' },
      options
    );
  };
  /**
   * Soft-delete a campaign and cascade to its child records.
   * @summary Delete Campaign
   */
  const campaignsDeleteCampaign = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<void>>
  ) => {
    return axiosInstance<void>(
      { url: `/campaigns/edit/${campaignId}`, method: 'DELETE' },
      options
    );
  };
  /**
   * @summary Mark All As Reviewed
   */
  const campaignsMarkAllAsReviewed = (
    campaignId: string,
    markAllAsReviewedPayload: MarkAllAsReviewedPayload,
    options?: SecondParameter<typeof axiosInstance<MarkAsReviewedResponse>>
  ) => {
    return axiosInstance<MarkAsReviewedResponse>(
      {
        url: `/campaigns/edit/${campaignId}/mark_all_as_reviewed`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: markAllAsReviewedPayload,
      },
      options
    );
  };
  /**
   * @summary Mark Multiple As Reviewed
   */
  const campaignsMarkMultipleAsReviewed = (
    markMultipleAsReviewedPayload: MarkMultipleAsReviewedPayload,
    options?: SecondParameter<typeof axiosInstance<MarkAsReviewedResponse>>
  ) => {
    return axiosInstance<MarkAsReviewedResponse>(
      {
        url: `/campaigns/mark_multiple_as_reviewed`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: markMultipleAsReviewedPayload,
      },
      options
    );
  };
  /**
   * @summary Bulk Pause Resume Multiple
   */
  const campaignsBulkPauseResumeMultiple = (
    bulkPauseResumeMultiplePayload: BulkPauseResumeMultiplePayload,
    options?: SecondParameter<typeof axiosInstance<BulkPauseResumeResponse>>
  ) => {
    return axiosInstance<BulkPauseResumeResponse>(
      {
        url: `/candidates/bulk_pause_resume_multiple`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkPauseResumeMultiplePayload,
      },
      options
    );
  };
  /**
   * Cancel candidates across jobs via the same USER_CANCELED flow as the per-job route.
   * @summary Bulk Cancel Multiple
   */
  const campaignsBulkCancelMultiple = (
    bulkCancelMultiplePayload: BulkCancelMultiplePayload,
    options?: SecondParameter<typeof axiosInstance<BulkCancelCampaignResponse>>
  ) => {
    return axiosInstance<BulkCancelCampaignResponse>(
      {
        url: `/candidates/bulk_cancel_multiple`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkCancelMultiplePayload,
      },
      options
    );
  };
  /**
   * @summary Bulk Remove Multiple
   */
  const campaignsBulkRemoveMultiple = (
    bulkRemoveMultiplePayload: BulkRemoveMultiplePayload,
    options?: SecondParameter<typeof axiosInstance<BulkRemoveResponse>>
  ) => {
    return axiosInstance<BulkRemoveResponse>(
      {
        url: `/candidates/bulk_remove_multiple`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkRemoveMultiplePayload,
      },
      options
    );
  };
  /**
   * Submit feedback for a web call interview.
   * @summary Submit Web Call Feedback
   */
  const campaignsSubmitWebCallFeedback = (
    webCallFeedbackRequest: WebCallFeedbackRequest,
    options?: SecondParameter<typeof axiosInstance<WebCallFeedbackResponse>>
  ) => {
    return axiosInstance<WebCallFeedbackResponse>(
      {
        url: `/web_call_feedback`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: webCallFeedbackRequest,
      },
      options
    );
  };
  /**
   * Add sourced candidates to a campaign.
   * @summary Add Sourced Candidates
   */
  const campaignsAddSourcedCandidates = (
    campaignId: string,
    addSourcedCandidatesPayload: AddSourcedCandidatesPayload,
    options?: SecondParameter<
      typeof axiosInstance<AddSourcedCandidatesResponse>
    >
  ) => {
    return axiosInstance<AddSourcedCandidatesResponse>(
      {
        url: `/campaigns/edit/${campaignId}/add_sourced_candidates`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addSourcedCandidatesPayload,
      },
      options
    );
  };
  /**
 * Queue resume scoring for all candidates in a campaign.

Customer-facing: invoked by the "Rescore Candidate Resumes" action in the
job More menu. Scoring runs on the bulk-operation worker; the browser polls
`GET /campaigns/edit/{campaign_id}/score-candidates/{operation_id}` until it
finishes. A repeat request while a run is queued or in progress returns that run.
 * @summary Trigger Candidate Scoring
 */
  const campaignsTriggerCandidateScoring = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<ScoringStartedResponse>>
  ) => {
    return axiosInstance<ScoringStartedResponse>(
      { url: `/campaigns/edit/${campaignId}/score-candidates`, method: 'POST' },
      options
    );
  };
  /**
   * Return a queued resume-scoring run's status and, once completed, its counts.
   * @summary Get Candidate Scoring Status
   */
  const campaignsGetCandidateScoringStatus = (
    campaignId: string,
    operationId: string,
    options?: SecondParameter<typeof axiosInstance<ScoringOperationResponse>>
  ) => {
    return axiosInstance<ScoringOperationResponse>(
      {
        url: `/campaigns/edit/${campaignId}/score-candidates/${operationId}`,
        method: 'GET',
      },
      options
    );
  };
  /**
 * Candidate-facing endpoint to view withdrawal page info via magic-link token.
Returns candidate name, job name, company name, and available withdrawal reasons.
 * @summary Get Withdrawal Info
 */
  const campaignsGetWithdrawalInfo = (
    token: string,
    options?: SecondParameter<typeof axiosInstance<WithdrawalInfoResponse>>
  ) => {
    return axiosInstance<WithdrawalInfoResponse>(
      { url: `/candidate/withdraw/${token}`, method: 'GET' },
      options
    );
  };
  /**
 * Process candidate withdrawal.
Uses TenzoStageOrchestrator to handle all NOT_INTERESTED actions:
- Cancels pending/invited calls
- Transitions SMS state
- Syncs to ATS (rejection + call stop note)
 * @summary Submit Withdrawal
 */
  const campaignsSubmitWithdrawal = (
    token: string,
    submitWithdrawalPayload: SubmitWithdrawalPayload,
    options?: SecondParameter<typeof axiosInstance<SubmitWithdrawalResponse>>
  ) => {
    return axiosInstance<SubmitWithdrawalResponse>(
      {
        url: `/candidate/withdraw/${token}/submit`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: submitWithdrawalPayload,
      },
      options
    );
  };
  /**
 * Candidate-facing endpoint for sourced candidates to view the not-interested page
via magic-link token.
 * @summary Get Uninterested Info
 */
  const campaignsGetUninterestedInfo = (
    token: string,
    options?: SecondParameter<typeof axiosInstance<UninterestedInfoResponse>>
  ) => {
    return axiosInstance<UninterestedInfoResponse>(
      { url: `/candidate/uninterested/${token}`, method: 'GET' },
      options
    );
  };
  /**
 * Mark a sourced candidate as not interested in the role.

Uses TenzoStageOrchestrator to handle all NOT_INTERESTED actions without collecting a
withdrawal reason (sourced candidates did not apply).
 * @summary Submit Uninterested
 */
  const campaignsSubmitUninterested = (
    token: string,
    options?: SecondParameter<typeof axiosInstance<SubmitUninterestedResponse>>
  ) => {
    return axiosInstance<SubmitUninterestedResponse>(
      { url: `/candidate/uninterested/${token}/submit`, method: 'POST' },
      options
    );
  };
  /**
   * @summary Cancel Pending Calls
   */
  const campaignsCancelPendingCalls = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<void>>
  ) => {
    return axiosInstance<void>(
      {
        url: `/campaigns/edit/${campaignId}/cancel_pending_calls`,
        method: 'POST',
      },
      options
    );
  };
  /**
   * @summary Bulk Remove Candidates
   */
  const campaignsBulkRemoveCandidates = (
    campaignId: string,
    bulkRemovePayload: BulkRemovePayload,
    options?: SecondParameter<typeof axiosInstance<BulkRemoveResponse>>
  ) => {
    return axiosInstance<BulkRemoveResponse>(
      {
        url: `/campaigns/edit/${campaignId}/bulk_remove`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkRemovePayload,
      },
      options
    );
  };
  /**
   * Bulk cancel candidates via USER_CANCELED orchestrator transition.
   * @summary Bulk Cancel Candidates
   */
  const campaignsBulkCancelCandidates = (
    campaignId: string,
    bulkCancelPayload: BulkCancelPayload,
    options?: SecondParameter<typeof axiosInstance<BulkCancelCampaignResponse>>
  ) => {
    return axiosInstance<BulkCancelCampaignResponse>(
      {
        url: `/campaigns/edit/${campaignId}/bulk_cancel`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkCancelPayload,
      },
      options
    );
  };
  /**
   * @summary Bulk Pause Resume Candidates
   */
  const campaignsBulkPauseResumeCandidates = (
    campaignId: string,
    bulkPauseResumePayload: BulkPauseResumePayload,
    options?: SecondParameter<typeof axiosInstance<BulkPauseResumeResponse>>
  ) => {
    return axiosInstance<BulkPauseResumeResponse>(
      {
        url: `/campaigns/edit/${campaignId}/bulk_pause_resume`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkPauseResumePayload,
      },
      options
    );
  };
  /**
   * @summary Bulk Update Candidate Feedback
   */
  const campaignsBulkUpdateCandidateFeedback = (
    campaignId: string,
    bulkUpdateCandidateFeedbackPayload: BulkUpdateCandidateFeedbackPayload,
    options?: SecondParameter<typeof axiosInstance<BulkFeedbackResponse>>
  ) => {
    return axiosInstance<BulkFeedbackResponse>(
      {
        url: `/campaigns/edit/${campaignId}/bulk_update_feedback`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkUpdateCandidateFeedbackPayload,
      },
      options
    );
  };
  /**
   * @summary Update Call Summary
   */
  const campaignsUpdateCallSummary = (
    callId: string,
    updateCallSummaryPayload: UpdateCallSummaryPayload,
    options?: SecondParameter<typeof axiosInstance<UpdateCallSummaryResponse>>
  ) => {
    return axiosInstance<UpdateCallSummaryResponse>(
      {
        url: `/call/${callId}/summary`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateCallSummaryPayload,
      },
      options
    );
  };
  /**
   * @summary Get Campaign Questions Paginated
   */
  const campaignsGetCampaignQuestionsPaginated = (
    campaignId: string,
    params?: CampaignsGetCampaignQuestionsPaginatedParams,
    options?: SecondParameter<
      typeof axiosInstance<CampaignQuestionsPaginatedResponse>
    >
  ) => {
    return axiosInstance<CampaignQuestionsPaginatedResponse>(
      {
        url: `/campaigns/view/${campaignId}/questions_paginated`,
        method: 'GET',
        params,
      },
      options
    );
  };
  /**
   * @summary Mark Question As Answered
   */
  const campaignsMarkQuestionAsAnswered = (
    markQuestionsAsAnsweredPayload: MarkQuestionsAsAnsweredPayload,
    options?: SecondParameter<typeof axiosInstance<MessageResponse>>
  ) => {
    return axiosInstance<MessageResponse>(
      {
        url: `/mark_questions_as_answered`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: markQuestionsAsAnsweredPayload,
      },
      options
    );
  };
  /**
   * @summary Mark Question As Unanswered
   */
  const campaignsMarkQuestionAsUnanswered = (
    markQuestionsAsAnsweredPayload: MarkQuestionsAsAnsweredPayload,
    options?: SecondParameter<typeof axiosInstance<MessageResponse>>
  ) => {
    return axiosInstance<MessageResponse>(
      {
        url: `/mark_questions_as_unanswered`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: markQuestionsAsAnsweredPayload,
      },
      options
    );
  };
  /**
   * @summary Update Campaign Permanent Link Questions
   */
  const campaignsUpdateCampaignPermanentLinkQuestions = (
    campaignId: string,
    updateCampaignPermanentLinkQuestionsPayload: UpdateCampaignPermanentLinkQuestionsPayload,
    options?: SecondParameter<typeof axiosInstance<MessageResponse>>
  ) => {
    return axiosInstance<MessageResponse>(
      {
        url: `/campaigns/edit/${campaignId}/update_permanent_link_questions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: updateCampaignPermanentLinkQuestionsPayload,
      },
      options
    );
  };
  /**
   * @summary Get Campaign Permanent Link Questions
   */
  const campaignsGetCampaignPermanentLinkQuestions = (
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<PermanentLinkQuestionsResponse>
    >
  ) => {
    return axiosInstance<PermanentLinkQuestionsResponse>(
      {
        url: `/campaigns/view/${campaignId}/permanent_link_questions`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * Save the script and other info needed to recreate a campaign to Cosmos.
   * @summary Save Script
   */
  const campaignsSaveScript = (
    campaignId: string,
    savedScriptPayload: SavedScriptPayload,
    params?: CampaignsSaveScriptParams,
    options?: SecondParameter<typeof axiosInstance<SaveScriptResponse>>
  ) => {
    return axiosInstance<SaveScriptResponse>(
      {
        url: `/campaigns/edit/${campaignId}/save_script`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: savedScriptPayload,
        params,
      },
      options
    );
  };
  /**
 * Propagate template changes to selected linked jobs via JobTemplateService.

SCRIPT and HYBRID both enqueue with frozen cosmos snapshots and apply the same
cosmos-patch pipeline in the bulk worker. Queues each job for background
processing via the bulk operations framework. Returns an operation_id for SSE
progress tracking.
 * @summary Propagate Template Via Ats
 */
  const campaignsPropagateTemplateViaAts = (
    templateId: string,
    propagateTemplatePayload: PropagateTemplatePayload,
    options?: SecondParameter<typeof axiosInstance<BulkOperationResponse>>
  ) => {
    return axiosInstance<BulkOperationResponse>(
      {
        url: `/campaigns/templates/${templateId}/propagate-via-ats`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: propagateTemplatePayload,
      },
      options
    );
  };
  /**
 * Dry-run preview of what propagating the draft template would change on a chunk of jobs.

Does not save the template or write to linked jobs. Clients should call this
repeatedly with chunks of job_ids to drive a progress bar.
 * @summary Preview Template Propagation
 */
  const campaignsPreviewTemplatePropagation = (
    templateId: string,
    propagationPreviewRequest: PropagationPreviewRequest,
    options?: SecondParameter<typeof axiosInstance<PropagationPreviewResponse>>
  ) => {
    return axiosInstance<PropagationPreviewResponse>(
      {
        url: `/campaigns/templates/${templateId}/propagation-preview`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: propagationPreviewRequest,
      },
      options
    );
  };
  /**
 * Run live hybrid generators for one linked job without writing.

Used by the save-template preview to show proposed AI copy. Confirm may send
the returned cache blob so the worker persists that text instead of regenerating.
 * @summary Generate Template Propagation Preview
 */
  const campaignsGenerateTemplatePropagationPreview = (
    templateId: string,
    jobGenerationPreviewRequest: JobGenerationPreviewRequest,
    options?: SecondParameter<
      typeof axiosInstance<JobGenerationPreviewResponse>
    >
  ) => {
    return axiosInstance<JobGenerationPreviewResponse>(
      {
        url: `/campaigns/templates/${templateId}/propagation-preview/generate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: jobGenerationPreviewRequest,
      },
      options
    );
  };
  /**
   * @summary Get Screening Questions
   */
  const campaignsGetScreeningQuestions = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<ScreeningQuestionsResponse>>
  ) => {
    return axiosInstance<ScreeningQuestionsResponse>(
      {
        url: `/campaigns/view/${campaignId}/screening_questions`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Get Script Timestamps
   */
  const campaignsGetScriptTimestamps = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<ScriptTimestampsResponse>>
  ) => {
    return axiosInstance<ScriptTimestampsResponse>(
      { url: `/campaigns/view/${campaignId}/script_timestamps`, method: 'GET' },
      options
    );
  };
  /**
   * @summary List Campaign Script Versions
   */
  const campaignsListCampaignScriptVersions = (
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<CampaignScriptVersionsListResponse>
    >
  ) => {
    return axiosInstance<CampaignScriptVersionsListResponse>(
      { url: `/campaigns/view/${campaignId}/script_versions`, method: 'GET' },
      options
    );
  };
  /**
   * @summary Get Script Version
   */
  const campaignsGetScriptVersion = (
    campaignId: string,
    versionId: string,
    options?: SecondParameter<typeof axiosInstance<ScriptVersionDetailResponse>>
  ) => {
    return axiosInstance<ScriptVersionDetailResponse>(
      {
        url: `/campaigns/view/${campaignId}/script_versions/${versionId}`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Restore Script Version
   */
  const campaignsRestoreScriptVersion = (
    campaignId: string,
    versionId: string,
    options?: SecondParameter<
      typeof axiosInstance<RestoreScriptVersionResponse>
    >
  ) => {
    return axiosInstance<RestoreScriptVersionResponse>(
      {
        url: `/campaigns/view/${campaignId}/script_versions/${versionId}/restore`,
        method: 'POST',
      },
      options
    );
  };
  /**
   * Generate grading criteria for an interview question.
   * @summary Generate Grading Criteria
   */
  const campaignsGenerateGradingCriteria = (
    gradingCriteriaRequest: GradingCriteriaRequest,
    options?: SecondParameter<typeof axiosInstance<GradingCriteriaResponse>>
  ) => {
    return axiosInstance<GradingCriteriaResponse>(
      {
        url: `/generate_grading_criteria`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: gradingCriteriaRequest,
      },
      options
    );
  };
  /**
   * Generate editable drafts from request copy without saving or sending messages.
   * @summary Generate Video Reminder Sequence
   */
  const generateVideoReminderSequence = (
    generateVideoReminderSequencePayload: GenerateVideoReminderSequencePayload,
    options?: SecondParameter<
      typeof axiosInstance<GenerateVideoReminderSequenceResponse>
    >
  ) => {
    return axiosInstance<GenerateVideoReminderSequenceResponse>(
      {
        url: `/campaigns/generate-video-reminder-sequence`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: generateVideoReminderSequencePayload,
      },
      options
    );
  };
  /**
   * Generate editable SMS bundles using only the supplied invitation copy.
   * @summary Generate Video Sms Reminder Sequence
   */
  const generateVideoSmsReminderSequence = (
    generateVideoSmsReminderSequencePayload: GenerateVideoSmsReminderSequencePayload,
    options?: SecondParameter<
      typeof axiosInstance<GenerateVideoSmsReminderSequenceResponse>
    >
  ) => {
    return axiosInstance<GenerateVideoSmsReminderSequenceResponse>(
      {
        url: `/campaigns/generate-video-sms-reminder-sequence`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: generateVideoSmsReminderSequencePayload,
      },
      options
    );
  };
  /**
   * @summary Generate Script
   */
  const campaignsGenerateScript = (
    campaignId: string,
    generateScriptPayload: GenerateScriptPayload,
    options?: SecondParameter<typeof axiosInstance<GeneratedScriptInfo>>
  ) => {
    return axiosInstance<GeneratedScriptInfo>(
      {
        url: `/campaigns/edit/${campaignId}/generate_script`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: generateScriptPayload,
      },
      options
    );
  };
  /**
   * @summary Generate New Script
   */
  const campaignsGenerateNewScript = (
    orgId: string,
    generateScriptPayload: GenerateScriptPayload,
    options?: SecondParameter<typeof axiosInstance<GeneratedScriptInfo>>
  ) => {
    return axiosInstance<GeneratedScriptInfo>(
      {
        url: `/org/${orgId}/generate_script`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: generateScriptPayload,
      },
      options
    );
  };
  /**
   * @summary Start Generate Script Job
   */
  const campaignsStartGenerateScriptJob = (
    orgId: string,
    generateScriptPayload: GenerateScriptPayload,
    options?: SecondParameter<typeof axiosInstance<ScriptGenerationJobAccepted>>
  ) => {
    return axiosInstance<ScriptGenerationJobAccepted>(
      {
        url: `/org/${orgId}/generate_script/jobs`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: generateScriptPayload,
      },
      options
    );
  };
  /**
   * @summary Get Generate Script Job
   */
  const campaignsGetGenerateScriptJob = (
    orgId: string,
    generationId: string,
    options?: SecondParameter<
      typeof axiosInstance<ScriptGenerationJobStatusResponse>
    >
  ) => {
    return axiosInstance<ScriptGenerationJobStatusResponse>(
      {
        url: `/org/${orgId}/generate_script/jobs/${generationId}`,
        method: 'GET',
      },
      options
    );
  };
  /**
 * Regenerate a single AI-generated section for a job derived from a hybrid template.

Runs only the relevant pipeline component(s) for the requested section,
patches the job's Cosmos document, and returns the regenerated content.
 * @summary Regenerate Section
 */
  const campaignsRegenerateSection = (
    campaignId: string,
    regenerateSectionPayload: RegenerateSectionPayload,
    options?: SecondParameter<typeof axiosInstance<RegenerateSectionResponse>>
  ) => {
    return axiosInstance<RegenerateSectionResponse>(
      {
        url: `/campaigns/edit/${campaignId}/regenerate-section`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: regenerateSectionPayload,
      },
      options
    );
  };
  /**
 * Regenerate all AI block questions on a template-derived job in a single LLM call.

All blocks are expanded together so the LLM has full cross-block context, preventing
duplicate questions between blocks and enabling coherent output.
 * @summary Regenerate All Ai Blocks
 */
  const campaignsRegenerateAllAiBlocks = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<RegenerateAiBlockResponse>>
  ) => {
    return axiosInstance<RegenerateAiBlockResponse>(
      {
        url: `/campaigns/edit/${campaignId}/regenerate-all-ai-blocks`,
        method: 'POST',
      },
      options
    );
  };
  /**
 * Regenerate one AI block's questions on a template-derived job.

Other AI blocks, hardcoded questions, and job-local questions are left unchanged.
 * @summary Regenerate Ai Block
 */
  const campaignsRegenerateAiBlock = (
    campaignId: string,
    regenerateAiBlockPayload: RegenerateAiBlockPayload,
    options?: SecondParameter<typeof axiosInstance<RegenerateAiBlockResponse>>
  ) => {
    return axiosInstance<RegenerateAiBlockResponse>(
      {
        url: `/campaigns/edit/${campaignId}/regenerate-ai-block`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: regenerateAiBlockPayload,
      },
      options
    );
  };
  /**
   * Delete a background info template and remove references from all scripts.
   * @summary Delete Background Info Template
   */
  const campaignsDeleteBackgroundInfoTemplate = (
    orgId: string,
    templateId: string,
    options?: SecondParameter<typeof axiosInstance<DeletedIdResponse>>
  ) => {
    return axiosInstance<DeletedIdResponse>(
      {
        url: `/org/${orgId}/background_info_templates/${templateId}`,
        method: 'DELETE',
      },
      options
    );
  };
  /**
   * Delete a script generation template and remove references from all scripts.
   * @summary Delete Script Generation Template
   */
  const campaignsDeleteScriptGenerationTemplate = (
    orgId: string,
    templateId: string,
    options?: SecondParameter<typeof axiosInstance<DeletedIdResponse>>
  ) => {
    return axiosInstance<DeletedIdResponse>(
      {
        url: `/org/${orgId}/script_generation_templates/${templateId}`,
        method: 'DELETE',
      },
      options
    );
  };
  /**
   * Endpoint to generate suggested screening questions for a campaign.
   * @summary Generate Suggested Questions
   */
  const campaignsGenerateSuggestedQuestions = (
    campaignId: string,
    options?: SecondParameter<
      typeof axiosInstance<SuggestedQuestionCategoriesResponse>
    >
  ) => {
    return axiosInstance<SuggestedQuestionCategoriesResponse>(
      {
        url: `/campaigns/edit/${campaignId}/generate-suggested-questions`,
        method: 'POST',
      },
      options
    );
  };
  /**
   * Endpoint to add a new category to the suggested questions.
   * @summary Add Suggested Questions Category
   */
  const campaignsAddSuggestedQuestionsCategory = (
    campaignId: string,
    addSuggestedQuestionsCategoryPayload: AddSuggestedQuestionsCategoryPayload,
    options?: SecondParameter<typeof axiosInstance<SuggestedQuestionsResponse>>
  ) => {
    return axiosInstance<SuggestedQuestionsResponse>(
      {
        url: `/campaigns/edit/${campaignId}/add-suggested-questions-category`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addSuggestedQuestionsCategoryPayload,
      },
      options
    );
  };
  /**
   * Endpoint to regenerate suggested questions for a specific category.
   * @summary Regenerate Suggested Questions
   */
  const campaignsRegenerateSuggestedQuestions = (
    campaignId: string,
    regenerateSuggestedQuestionsPayload: RegenerateSuggestedQuestionsPayload,
    options?: SecondParameter<typeof axiosInstance<SuggestedQuestionsResponse>>
  ) => {
    return axiosInstance<SuggestedQuestionsResponse>(
      {
        url: `/campaigns/edit/${campaignId}/regenerate-suggested-questions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: regenerateSuggestedQuestionsPayload,
      },
      options
    );
  };
  /**
 * Trigger background info validation and return the result directly.
This replaces the async validation that was previously done in save_script.

If force=True, bypasses Redis cache to force re-validation even if inputs haven't changed.
Useful when template contents have changed but template IDs remain the same.
 * @summary Trigger Background Validation
 */
  const campaignsTriggerBackgroundValidation = (
    campaignId: string,
    triggerValidationPayload: TriggerValidationPayload,
    options?: SecondParameter<
      typeof axiosInstance<TriggerBackgroundValidationResponse>
    >
  ) => {
    return axiosInstance<TriggerBackgroundValidationResponse>(
      {
        url: `/campaigns/edit/${campaignId}/trigger_background_validation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: triggerValidationPayload,
      },
      options
    );
  };
  /**
 * Transform screening questions using a natural language prompt.

Takes the current screening questions and a user prompt, uses AI to determine
what changes to make, and returns the updated questions with a changelog.

No database writes — the frontend applies the returned questions.
 * @summary Chat Update Screening Questions
 */
  const campaignsChatUpdateScreeningQuestions = (
    chatScreeningRequest: ChatScreeningRequest,
    options?: SecondParameter<typeof axiosInstance<ChatScreeningResponse>>
  ) => {
    return axiosInstance<ChatScreeningResponse>(
      {
        url: `/campaigns/chat-screening`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: chatScreeningRequest,
      },
      options
    );
  };
  /**
   * Load the job's script from Cosmos together with the SQL settings the editor reads.
   * @summary Get Script
   */
  const campaignsGetScript = (
    campaignId: string,
    options?: SecondParameter<typeof axiosInstance<ScriptReadResponse>>
  ) => {
    return axiosInstance<ScriptReadResponse>(
      { url: `/campaigns/view/${campaignId}/script`, method: 'GET' },
      options
    );
  };
  return {
    campaignsSearchCampaigns,
    campaignsGetOrgCampaignsFiltered,
    campaignsSearchOrgJobsForPicker,
    campaignsGetOrgCampaignJobSummaryMetrics,
    campaignsGetCampaignStatsSummary,
    campaignsGetCampaignStats,
    campaignsGetCandidateResumeDetailsForCampaign,
    campaignsGetResumeFilteringSettingsForCampaign,
    campaignsGetNotificationsCount,
    campaignsGetNotifications,
    campaignsGetCandidatesWithCalls,
    campaignsBulkExportCampaignCandidates,
    campaignsBulkExportCandidates,
    campaignsGetClients,
    campaignsGetOutroTemplates,
    campaignsGetAiCallerName,
    campaignsGetScheduleFollowUpUserEmails,
    campaignsGetAllCandidateIdsForCampaign,
    campaignsPauseCampaign,
    campaignsGetCampaign,
    campaignsGetCampaignTranscriptPermissions,
    campaignsResumeCampaign,
    campaignsUpdateCampaignSettings,
    campaignsDuplicateCampaign,
    campaignsPatchCampaignBackgroundInfo,
    campaignsGetCampaignRequirements,
    campaignsGetCampaignSourcingRequirements,
    campaignsGetAutoMatchSourcingSettings,
    campaignsUpdateAutoMatchSourcingSettings,
    campaignsUpdateCampaignJobs,
    campaignsGetCampaignJobs,
    campaignsDeleteCampaign,
    campaignsMarkAllAsReviewed,
    campaignsMarkMultipleAsReviewed,
    campaignsBulkPauseResumeMultiple,
    campaignsBulkCancelMultiple,
    campaignsBulkRemoveMultiple,
    campaignsSubmitWebCallFeedback,
    campaignsAddSourcedCandidates,
    campaignsTriggerCandidateScoring,
    campaignsGetCandidateScoringStatus,
    campaignsGetWithdrawalInfo,
    campaignsSubmitWithdrawal,
    campaignsGetUninterestedInfo,
    campaignsSubmitUninterested,
    campaignsCancelPendingCalls,
    campaignsBulkRemoveCandidates,
    campaignsBulkCancelCandidates,
    campaignsBulkPauseResumeCandidates,
    campaignsBulkUpdateCandidateFeedback,
    campaignsUpdateCallSummary,
    campaignsGetCampaignQuestionsPaginated,
    campaignsMarkQuestionAsAnswered,
    campaignsMarkQuestionAsUnanswered,
    campaignsUpdateCampaignPermanentLinkQuestions,
    campaignsGetCampaignPermanentLinkQuestions,
    campaignsSaveScript,
    campaignsPropagateTemplateViaAts,
    campaignsPreviewTemplatePropagation,
    campaignsGenerateTemplatePropagationPreview,
    campaignsGetScreeningQuestions,
    campaignsGetScriptTimestamps,
    campaignsListCampaignScriptVersions,
    campaignsGetScriptVersion,
    campaignsRestoreScriptVersion,
    campaignsGenerateGradingCriteria,
    generateVideoReminderSequence,
    generateVideoSmsReminderSequence,
    campaignsGenerateScript,
    campaignsGenerateNewScript,
    campaignsStartGenerateScriptJob,
    campaignsGetGenerateScriptJob,
    campaignsRegenerateSection,
    campaignsRegenerateAllAiBlocks,
    campaignsRegenerateAiBlock,
    campaignsDeleteBackgroundInfoTemplate,
    campaignsDeleteScriptGenerationTemplate,
    campaignsGenerateSuggestedQuestions,
    campaignsAddSuggestedQuestionsCategory,
    campaignsRegenerateSuggestedQuestions,
    campaignsTriggerBackgroundValidation,
    campaignsChatUpdateScreeningQuestions,
    campaignsGetScript,
  };
};
export type CampaignsSearchCampaignsResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsSearchCampaigns']>
  >
>;
export type CampaignsGetOrgCampaignsFilteredResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGetOrgCampaignsFiltered']
    >
  >
>;
export type CampaignsSearchOrgJobsForPickerResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsSearchOrgJobsForPicker']
    >
  >
>;
export type CampaignsGetOrgCampaignJobSummaryMetricsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCampaigns
      >['campaignsGetOrgCampaignJobSummaryMetrics']
    >
  >
>;
export type CampaignsGetCampaignStatsSummaryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGetCampaignStatsSummary']
    >
  >
>;
export type CampaignsGetCampaignStatsResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGetCampaignStats']>
  >
>;
export type CampaignsGetCandidateResumeDetailsForCampaignResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCampaigns
      >['campaignsGetCandidateResumeDetailsForCampaign']
    >
  >
>;
export type CampaignsGetResumeFilteringSettingsForCampaignResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCampaigns
      >['campaignsGetResumeFilteringSettingsForCampaign']
    >
  >
>;
export type CampaignsGetNotificationsCountResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGetNotificationsCount']
    >
  >
>;
export type CampaignsGetNotificationsResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGetNotifications']>
  >
>;
export type CampaignsGetCandidatesWithCallsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGetCandidatesWithCalls']
    >
  >
>;
export type CampaignsBulkExportCampaignCandidatesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsBulkExportCampaignCandidates']
    >
  >
>;
export type CampaignsBulkExportCandidatesResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsBulkExportCandidates']>
  >
>;
export type CampaignsGetClientsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaigns>['campaignsGetClients']>>
>;
export type CampaignsGetOutroTemplatesResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGetOutroTemplates']>
  >
>;
export type CampaignsGetAiCallerNameResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGetAiCallerName']>
  >
>;
export type CampaignsGetScheduleFollowUpUserEmailsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGetScheduleFollowUpUserEmails']
    >
  >
>;
export type CampaignsGetAllCandidateIdsForCampaignResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGetAllCandidateIdsForCampaign']
    >
  >
>;
export type CampaignsPauseCampaignResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaigns>['campaignsPauseCampaign']>>
>;
export type CampaignsGetCampaignResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaigns>['campaignsGetCampaign']>>
>;
export type CampaignsGetCampaignTranscriptPermissionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCampaigns
      >['campaignsGetCampaignTranscriptPermissions']
    >
  >
>;
export type CampaignsResumeCampaignResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsResumeCampaign']>
  >
>;
export type CampaignsUpdateCampaignSettingsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsUpdateCampaignSettings']
    >
  >
>;
export type CampaignsDuplicateCampaignResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsDuplicateCampaign']>
  >
>;
export type CampaignsPatchCampaignBackgroundInfoResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsPatchCampaignBackgroundInfo']
    >
  >
>;
export type CampaignsGetCampaignRequirementsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGetCampaignRequirements']
    >
  >
>;
export type CampaignsGetCampaignSourcingRequirementsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCampaigns
      >['campaignsGetCampaignSourcingRequirements']
    >
  >
>;
export type CampaignsGetAutoMatchSourcingSettingsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGetAutoMatchSourcingSettings']
    >
  >
>;
export type CampaignsUpdateAutoMatchSourcingSettingsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCampaigns
      >['campaignsUpdateAutoMatchSourcingSettings']
    >
  >
>;
export type CampaignsUpdateCampaignJobsResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsUpdateCampaignJobs']>
  >
>;
export type CampaignsGetCampaignJobsResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGetCampaignJobs']>
  >
>;
export type CampaignsDeleteCampaignResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsDeleteCampaign']>
  >
>;
export type CampaignsMarkAllAsReviewedResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsMarkAllAsReviewed']>
  >
>;
export type CampaignsMarkMultipleAsReviewedResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsMarkMultipleAsReviewed']
    >
  >
>;
export type CampaignsBulkPauseResumeMultipleResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsBulkPauseResumeMultiple']
    >
  >
>;
export type CampaignsBulkCancelMultipleResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsBulkCancelMultiple']>
  >
>;
export type CampaignsBulkRemoveMultipleResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsBulkRemoveMultiple']>
  >
>;
export type CampaignsSubmitWebCallFeedbackResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsSubmitWebCallFeedback']
    >
  >
>;
export type CampaignsAddSourcedCandidatesResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsAddSourcedCandidates']>
  >
>;
export type CampaignsTriggerCandidateScoringResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsTriggerCandidateScoring']
    >
  >
>;
export type CampaignsGetCandidateScoringStatusResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGetCandidateScoringStatus']
    >
  >
>;
export type CampaignsGetWithdrawalInfoResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGetWithdrawalInfo']>
  >
>;
export type CampaignsSubmitWithdrawalResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsSubmitWithdrawal']>
  >
>;
export type CampaignsGetUninterestedInfoResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGetUninterestedInfo']>
  >
>;
export type CampaignsSubmitUninterestedResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsSubmitUninterested']>
  >
>;
export type CampaignsCancelPendingCallsResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsCancelPendingCalls']>
  >
>;
export type CampaignsBulkRemoveCandidatesResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsBulkRemoveCandidates']>
  >
>;
export type CampaignsBulkCancelCandidatesResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsBulkCancelCandidates']>
  >
>;
export type CampaignsBulkPauseResumeCandidatesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsBulkPauseResumeCandidates']
    >
  >
>;
export type CampaignsBulkUpdateCandidateFeedbackResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsBulkUpdateCandidateFeedback']
    >
  >
>;
export type CampaignsUpdateCallSummaryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsUpdateCallSummary']>
  >
>;
export type CampaignsGetCampaignQuestionsPaginatedResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGetCampaignQuestionsPaginated']
    >
  >
>;
export type CampaignsMarkQuestionAsAnsweredResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsMarkQuestionAsAnswered']
    >
  >
>;
export type CampaignsMarkQuestionAsUnansweredResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsMarkQuestionAsUnanswered']
    >
  >
>;
export type CampaignsUpdateCampaignPermanentLinkQuestionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCampaigns
      >['campaignsUpdateCampaignPermanentLinkQuestions']
    >
  >
>;
export type CampaignsGetCampaignPermanentLinkQuestionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCampaigns
      >['campaignsGetCampaignPermanentLinkQuestions']
    >
  >
>;
export type CampaignsSaveScriptResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaigns>['campaignsSaveScript']>>
>;
export type CampaignsPropagateTemplateViaAtsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsPropagateTemplateViaAts']
    >
  >
>;
export type CampaignsPreviewTemplatePropagationResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsPreviewTemplatePropagation']
    >
  >
>;
export type CampaignsGenerateTemplatePropagationPreviewResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getCampaigns
      >['campaignsGenerateTemplatePropagationPreview']
    >
  >
>;
export type CampaignsGetScreeningQuestionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGetScreeningQuestions']
    >
  >
>;
export type CampaignsGetScriptTimestampsResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGetScriptTimestamps']>
  >
>;
export type CampaignsListCampaignScriptVersionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsListCampaignScriptVersions']
    >
  >
>;
export type CampaignsGetScriptVersionResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGetScriptVersion']>
  >
>;
export type CampaignsRestoreScriptVersionResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsRestoreScriptVersion']>
  >
>;
export type CampaignsGenerateGradingCriteriaResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGenerateGradingCriteria']
    >
  >
>;
export type GenerateVideoReminderSequenceResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['generateVideoReminderSequence']>
  >
>;
export type GenerateVideoSmsReminderSequenceResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['generateVideoSmsReminderSequence']
    >
  >
>;
export type CampaignsGenerateScriptResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGenerateScript']>
  >
>;
export type CampaignsGenerateNewScriptResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGenerateNewScript']>
  >
>;
export type CampaignsStartGenerateScriptJobResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsStartGenerateScriptJob']
    >
  >
>;
export type CampaignsGetGenerateScriptJobResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsGetGenerateScriptJob']>
  >
>;
export type CampaignsRegenerateSectionResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsRegenerateSection']>
  >
>;
export type CampaignsRegenerateAllAiBlocksResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsRegenerateAllAiBlocks']
    >
  >
>;
export type CampaignsRegenerateAiBlockResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCampaigns>['campaignsRegenerateAiBlock']>
  >
>;
export type CampaignsDeleteBackgroundInfoTemplateResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsDeleteBackgroundInfoTemplate']
    >
  >
>;
export type CampaignsDeleteScriptGenerationTemplateResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsDeleteScriptGenerationTemplate']
    >
  >
>;
export type CampaignsGenerateSuggestedQuestionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsGenerateSuggestedQuestions']
    >
  >
>;
export type CampaignsAddSuggestedQuestionsCategoryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsAddSuggestedQuestionsCategory']
    >
  >
>;
export type CampaignsRegenerateSuggestedQuestionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsRegenerateSuggestedQuestions']
    >
  >
>;
export type CampaignsTriggerBackgroundValidationResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsTriggerBackgroundValidation']
    >
  >
>;
export type CampaignsChatUpdateScreeningQuestionsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCampaigns>['campaignsChatUpdateScreeningQuestions']
    >
  >
>;
export type CampaignsGetScriptResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCampaigns>['campaignsGetScript']>>
>;
